// src/hooks/useSearchTickers.js
import { useState, useEffect } from "react";
import tickers from "../data/tickers.json";

export default function useSearchTickers(input) {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (!input) return setSuggestions([]);
    const matches = tickers
      .filter(
        (t) =>
          t.ticker?.toUpperCase().startsWith(input.toUpperCase()) ||
          t.name?.toUpperCase().startsWith(input.toUpperCase())
      )
      .slice(0, 8);
    setSuggestions(matches);
  }, [input]);

  return suggestions;
}
